import * as React from 'react';
import type { SVGProps } from 'react';
const IconMiniJob = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconMiniJob"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18 5.07A8.04 8.04 0 0 1 20.93 8H23v8h-2.07A8.04 8.04 0 0 1 18 18.93V21h-6v-1h-2v1H4v-3.708A7.97 7.97 0 0 1 2 12c0-1.214.271-2.364.755-3.395A3 3 0 0 1 1.25 6h1.5c0 .565.309 1.056.767 1.314A7.99 7.99 0 0 1 10 4h3a5 5 0 0 1 4-2h1zm-2-.9a3 3 0 0 0-1.6 1.331L14.112 6H10a6 6 0 0 0-4.286 10.2l.286.29V19h2v-1.224l1.142.163q.42.06.858.061h4v1h2v-1.306l.571-.271a6.03 6.03 0 0 0 2.852-2.852l.271-.571H21v-4h-1.306l-.271-.571a6.03 6.03 0 0 0-2.852-2.852L16 6.306zM16 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-4 .25H8v-1.5h4z"
    />
  </svg>
);
export default IconMiniJob;
